// user
export const LOGIN_USER = "LOGIN_USER";
export const LOGOUT_USER = "LOGOUT_USER";
export const UPDATE_USER = "UPDATE_USER";

// Upload Progress

export const EXPIRED_LICENSE = "EXPIRED_LICENSE";

export const EXPIRED_INSURANCE = "EXPIRED_INSURANCE";

export const EXPIRED_CONTRACT = "EXPIRED_CONTRACT";

export const NEW_CONTRACT = "NEW_CONTRACT";

export const CUSTOMER_ID = "CUSTOMER_ID";
export const EMPLOYEE_ID = "EMPLOYEE_ID";
export const VEHICLE_ID = "VEHICLE_ID";
export const INDIVIDUAL_CUSTOMER = "INDIVIDUAL_CUSTOMER";
export const PERMISSIONS = "PERMISSIONS";
